import styled from 'styled-components';

import ErrorPage from 'ggApp/shared/screens/ErrorPage/Page500';

export const ErrorScreen = styled(ErrorPage)`
    flex: 1 0 auto;
`;
